var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero-head has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chapter.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('p', {
    staticClass: "content is-medium",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.chapter.intro_text))
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "section score-slideshow"
  }, [_vm._m(0), _vm._v(" "), _c('agile', _vm._l((_vm.scores), function(score, index) {
    return _c('router-link', {
      key: ("score-" + index),
      staticClass: "slide",
      class: "slide--#{index + 1}",
      attrs: {
        "to": ("/chapter/" + (_vm.chapter.id) + "/score/" + (index + 1) + "/")
      }
    }, [_c('div', {
      staticClass: "slide-text has-text-centered"
    }, [(score.title) ? _c('h3', {
      staticClass: "slide-title"
    }, [_vm._v(_vm._s(score.title))]) : _vm._e(), _vm._v(" "), (score.author) ? _c('p', [_vm._v(_vm._s(score.author))]) : _vm._e()]), _vm._v(" "), (score.image) ? _c('img', {
      staticClass: "slide-image",
      attrs: {
        "src": _vm.slideshowImage(score)
      }
    }) : _vm._e()])
  }))], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "title is-1"
  }, [_vm._v("The Score")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32c3193a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Score.vue
// module id = rE4s
// module chunks = 0